import { ElementInfo, ResizedItem } from '@model/element-resizing.model';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject , of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OnResizeService {

  private resizeObserver: any;
  private elementsBeingObserved: ElementInfo[] = [];

  public _resizeCardBilletWks = new BehaviorSubject<any>(null);
  resizeCardBilletWks$ = this._resizeCardBilletWks.asObservable();

  public _resizeNumberLineBookWks = new BehaviorSubject<any>(null);
  resizeNumberLineBookWks$ = this._resizeNumberLineBookWks.asObservable();

  constructor() { }

  subscribeElement(target: Element, delayTime: number) {
    if (this.elementsBeingObserved.find(el => el.target === target)) {
      return null;
    }
    if (!this.resizeObserver) {
      this.resizeObserver = new (window as any).ResizeObserver(this.handleElementResizing.bind(this));
    }
    this.resizeObserver.observe(target);
    const newElement: ElementInfo = {
      target,
      subject: new Subject(),
      delayTime
    };
    this.elementsBeingObserved.push(newElement);
    return newElement.subject.asObservable();
  }

  unsubscribeElement(target: Element) {
    const elementInfo = this.elementsBeingObserved.find(el => el.target === target);
    if (!elementInfo) {
      return;
    }
    this.resizeObserver.unobserve(target);
    this.elementsBeingObserved = this.elementsBeingObserved.filter(el => el.target !== target);
    if (this.elementsBeingObserved.length === 0) {
      this.resizeObserver.disconnect();
    }
  }

  private handleElementResizing(event: ResizedItem[]) {
    const targetInfo:any = this.elementsBeingObserved.find(el => el.target === event[0].target);
    if (!targetInfo) {
      return;
    }
    if (targetInfo.delayedEmission) {
      clearTimeout(targetInfo.delayedEmission);
    }
    targetInfo.delayedEmission = setTimeout(() => {
      targetInfo.subject.next(event[0].contentRect);
    }, targetInfo.delayTime);
  }

}
